module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-7.f02b9fdf.webp";